import { render, staticRenderFns } from "./IjroIntizomi.vue?vue&type=template&id=0d9d5004&"
import script from "./IjroIntizomi.vue?vue&type=script&lang=js&"
export * from "./IjroIntizomi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports